import React from "react";
import "./about.scss";
import {Link} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import AppFooter from "../../../components/appFooter";


export default function About(props) {
    return (
        <div className={"mainDiv"}>
            <div className="mb-auto component-about">
                <div className="brand-bg-inverse-color fancyFont">
                    <div className="container">
                        <div className="navbar navbar-expand-sm navbar-dark brand-bg-inverse-color">
                            <Link to={"/"} className="navbar-brand" routerLink="/login">
                                <img src={require("../../../assets/logo.png")} alt="" width={'140px'}/>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="container main-content fancyFont">
                    <div className="row">
                        <div className="col-lg-12 mb-3">
                            <img src={require("../../../assets/about-header.jpg")} className="img-fluid" alt={""}/>
                        </div>

                        <div className="col-lg-12 mb-2">
                            <h3 className="h3 brand-text-color inner-header">About</h3>
                        </div>

                        <div className="col-lg-12">
                            <p>
                                MemonID.com is an independent entity which came into existence
                                with the sole purpose of working as An agency helping community
                                organizations taking better decisions in their charitable &amp;
                                social activities by providing accurate information of community
                                as a whole and if needed individual’s information.
                            </p>

                            <p>
                                As Bohra, Khoja &amp; Jain community, we don’t have a census of
                                our community or unique identity allotted to our members who in
                                many cases help us track the progress of individual after various
                                social benefits and help passed on to them.
                            </p>

                            <p>
                                <strong>www.memonid.com shall serve as:</strong>
                            </p>
                            <p>
                                - A digital platform to connect the entire memon community.
                                <br/>
                                - A connection platform for all the members to seek help or
                                contribute to the community.
                                <br/>
                                - An exclusive search platform for the memon community wherein you
                                can find and access all the community related information.
                                <br/>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <AppFooter/>
        </div>
    );
}
